import * as React from 'react';
import { SVGProps } from 'react';

const IconPriceLabelSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M20.342 2h-7.851c-.436 0-.873.174-1.134.436l-8.899 8.986c-.61.61-.61 1.658 0 2.268l7.852 7.852c.61.61 1.657.61 2.268 0l8.986-8.986c.262-.262.436-.698.436-1.134V3.57C22 2.698 21.302 2 20.342 2Zm-3.576 6.98a1.75 1.75 0 0 1-1.745-1.746c0-.96.785-1.744 1.744-1.744.96 0 1.745.785 1.745 1.744a1.75 1.75 0 0 1-1.745 1.745Z" />
  </svg>
);
export default IconPriceLabelSizeM;
